module.exports = __webpack_public_path__ + "5e2278c30b5841463c0a66dc82e7049b.jpg";